import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "redo-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.4697 5.53033C16.1768 5.23744 16.1768 4.76256 16.4697 4.46967C16.7626 4.17678 17.2374 4.17678 17.5303 4.46967L20.5303 7.46967C20.6768 7.61612 20.75 7.80806 20.75 8C20.75 8.10169 20.7298 8.19866 20.6931 8.28709C20.6565 8.37555 20.6022 8.45842 20.5303 8.53033L17.5303 11.5303C17.2374 11.8232 16.7626 11.8232 16.4697 11.5303C16.1768 11.2374 16.1768 10.7626 16.4697 10.4697L18.1893 8.75H11C8.03743 8.75 5.75 10.9363 5.75 13.5C5.75 16.0637 8.03743 18.25 11 18.25H19C19.4142 18.25 19.75 18.5858 19.75 19C19.75 19.4142 19.4142 19.75 19 19.75H11C7.33457 19.75 4.25 17.0123 4.25 13.5C4.25 9.98768 7.33457 7.25 11 7.25H18.1893L16.4697 5.53033Z" }, null, -1)
  ])))
}
export default { render: render }